import { compose, bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { TealiumParams, trackPageView } from '@is24at/react-tracking';
import { withTealium, withTracking } from '@is24at/react-tracking/redux';
import { asyncConnect } from 'core/reduxAsync';
import { byBaseUrl, byImageResizeUrl } from 'core/runtimeConfigReducer';
import { type AsyncItem } from 'core/reduxAsync/types';
import { fetchExposePage } from '../../modules/exposePageAsyncProps';
import ExposeView from '../ExposeView';

const mapStateToProps = (state: any) => ({
  expose: state.expose.view,
  baseUrl: byBaseUrl(state),
  httpStatus: state.expose.httpStatus,
  imageResizeUrl: byImageResizeUrl(state),
});

const mapDispatchToProps = (dispatch: any) => {
  const Actions = bindActionCreators(
    {
      trackPageView,
    },
    dispatch,
  );
  return {
    trackingFn: () =>
      Actions.trackPageView({
        [TealiumParams.PAGE_TITLE]: 'is24.at.anbieter.profile',
      }),
  };
};

const asyncProps = {
  key: 'pageData',
  promise: fetchExposePage,
} satisfies AsyncItem;

const ExposeViewContainer = compose(
  asyncConnect(asyncProps, mapStateToProps, mapDispatchToProps),
  withRouter,
  withTracking(),
  withTealium,
)(ExposeView);

export default ExposeViewContainer;
